import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AccountBird from 'components/atoms/AccountBird'

const styles = theme => ({
  container: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
  },
  banner: {
    width: '100%',
  },
  fade: {
    top: 0,
    right: 0,
    bottom: 0,
    width: 20,
    display: 'none',
    position: 'absolute',
    [theme.breakpoints.up('xl')]: {
      display: 'block',
    },
  },
})

const GoodnatureAccountBanner = ({ classes }) => (
  <section className={classes.container}>
    <AccountBird />
    <div className={classes.fade} />
  </section>
)

GoodnatureAccountBanner.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(GoodnatureAccountBanner)



// WEBPACK FOOTER //
// ./src/components/atoms/GoodnatureAccountBanner.js